import { getQueryParamValue } from "@chatfood/core-utils";
import {
  useDirectBackend,
  useLogger,
  defineNuxtRouteMiddleware,
} from "#imports";
import { isClient } from "@/utils/is-client";

export default defineNuxtRouteMiddleware(async (to) => {
  const QUERY_ID = "accessToken";
  const ssoToken = getQueryParamValue(to.query, QUERY_ID);

  if (isClient() || !ssoToken) return;

  const logger = useLogger();
  logger.info("Authorizing session with SSO token.", { ssoToken });

  const { authRepo } = useDirectBackend();

  try {
    await authRepo.exchangeSsoToken({
      token: ssoToken,
    });

    logger.info("Session authorized using SSO token.", {});
  } catch (error: any) {
    logger.error("Failed to authorize the session using the SSO token.", {
      ssoToken,
      error: error instanceof Error ? error.message : error,
    });
  }
});
